<template>
  <div class="list">
    <DatesPopUp
      :showPopUp="showPopUp"
      v-on:dateInfo="(value)=>{searchNewDate(value)}"
      v-on:close="togglePopUpVisibility"
    />
    <div class="list__menu" v-if="listArray && mainList">
      <div class="list__menu-square">
      </div>
      <div class="list__menu-triangle">
      </div>
      <div
        class="list__menu-note-select"
        v-if="optionsArray && !empty && options !== '11'"
      >
        Notowanie nr
        <div
          class="list__menu-show-info"
          @click="toggleMenuShowInfo"
        >
          <p>
            {{defaultSelected.label}}
            <svg width="14" height="10"  class="vs__open-indicator">
              <path d="M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z">
              </path>
            </svg>
          </p>
          <div
            class="list__menu-show-options"
            v-if="menuShowInfo"
            v-on-clickaway="closeMenuInfoBar"
          >
            <div
              v-for="(item, index) in optionsForLists"
              :key="index"
              @click="()=>{setDefaultselect(item)}"
            >
              {{item.label}}
            </div>
            <infinite-loading
              @infinite="infiniteDownloadList"
            >
              <div slot="no-more"></div>
              <div slot="no-results"></div>
            </infinite-loading>
          </div>
        </div>
        <span style="display:none">z dnia
          <span @click="togglePopUpVisibility">
            {{ selDate }}
            <svg width="14" height="10"  class="vs__open-indicator">
              <path d="M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z">
              </path>
            </svg>
          </span>
        </span>
      </div>
    </div>
    <div
      class="list__menu-to-vote"
      v-if="mainList && !empty && options !== '11'  && showVoteList()"
      @click="showToVoteList"
    >
      NAGRANIA DO GŁOSOWANIA
    </div>
    <div
      v-else-if="!empty  && showVoteList()"
      class="list__menu-to-vote"
      @click="backToList"
    >
        ZOBACZ ARCHIWALNE NOTOWANIA
    </div>
    <div
      class="list__first-list-element"
    >
      <div
        v-for="(item, index) in firstPlace"
        :key="index + '__first'"
      >
        <ListFirstElement
          v-if="listArray && mainList"
          :firstElement="item"
          :top="isWeekly"
          :actualPlay="actualPlay"
          :isPlaying="isPlaying"
          v-on:songURL="(value)=>{playMP3(value)}"
          :mainList="mainList"
          :listNumber="options"
        />
      </div>
      <VoteBanner
        v-if="listArray && !mainList && options==1"
      />
            <VoteBannerPTWC v-if="listArray && !mainList && options==3"/>

    </div>
    <div
      class="list__column"
      v-if="listWithout1place"
    >
      <div class="list__column-left">
        <RestOfTheList
          :arrayElements="listWithout1place"
          :top="weekElement"
          :actualPlay="actualPlay"
          :isPlaying="isPlaying"
          :indexOfStart="mainList"
          v-on:songURL="(value)=>{playMP3(value)}"
          v-if="showlist"
          :listNumber="options"
          :listDivide="listDivide"
          :mainList="mainList"
           :canVote="canVote"
          :special="special"
        />
        <infinite-loading
          @infinite="infiniteHandler"
          v-if="!mainList"
        >
          <div slot="no-more"></div>
          <div slot="no-results"></div>
        </infinite-loading>
      </div>
      <div class="list__column-right" v-if="!empty">
        <Banner
          photo='/img/polskiTopWsz.png'
          site='/polskitopwszechczasow'
        />
        <Banner
          photo='/img/topWszech.png'
          site='/topwszechczasow'
          v-if="!checkIf26ItIS()"
        />
        <Banner
          photo='/img/topwszech26.png'
          site='/topwszechczasow'
          v-if="checkIf26ItIS()"
        />
        <NewSongs
          :listNumber="options"
          :actualPlay="actualPlay"
          :isPlaying="isPlaying"
          v-on:songURL="(value)=>{playMP3(value)}"
          v-if="options==='1'"
        />
        <FromArchive
          :actualPlay="actualPlay"
          :isPlaying="isPlaying"
          v-on:songURL="(value)=>{playMP3(value)}"
        />
        <!-- <SponsorBanner/> -->
        <SpecialNote/>
      </div>
    </div>
    <div id="player">
        <audio src="" ref="audioPlayer">
        </audio>
    </div>
  </div>
</template>

<script>
import Banner from '@/components/Banner/Mobile/Banner.vue';
import DatesPopUp from '@/components/DatesPopUp/Mobile/DatesPopUp.vue';
import FromArchive from '@/components/FromArchive/Mobile/FromArchive.vue';
import NewSongs from '@/components/NewSongOnList/Mobile/NewSongOnList.vue';
import ListFirstElement from '@/components/ListFirstElement/Mobile/ListFirstElement.vue';
import RestOfTheList from '@/components/RestOfTheList/Mobile/RestOfTheList.vue';
import SpecialNote from '@/components/SpecNoteComp/Mobile/SpecNoteComp.vue';
// import SponsorBanner from '@/components/SponsorBanner/Mobile/SponsorBanner.vue';
import VoteBanner from '@/components/VoteBanner/Mobile/VoteBanner.vue';
import VoteBannerPTWC from  '@/components/VoteBannerPTWC/Mobile/VoteBannerPTWC.vue';

import InfiniteLoading from 'vue-infinite-loading';
import mixin from '../mixin';

export default {
  mixins: [mixin],
  components: {
    DatesPopUp,
    ListFirstElement,
    NewSongs,
    RestOfTheList,
    FromArchive,
    Banner,
    // SponsorBanner,
    SpecialNote,
    VoteBanner,
    VoteBannerPTWC,
    InfiniteLoading
  }
}
</script>

<style scoped lang="scss">
  .list {
    width: 100%;
    height: 100%;
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    &__menu {
      width: 95%;
      margin: 1rem auto 0 auto;
      display: flex;
      background-color: rgba(45,35,76,0.6);
      border-radius: 5px;
      height: 4rem;
      color: #c5d0ee;
      font-size: 0.9rem;
      align-items: center;
      font-family: 'Poppins', sans-serif;
    }
    &__menu-square {
      width: 4rem;
      height: 4rem;
      background-color: #952d6e;
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
    }
    &__menu-triangle {
      border-top: 2rem solid transparent;
      border-bottom: 2rem solid transparent;
      border-left: 2rem solid #952d6e;
    }
    &__menu-note-select {
      min-width: 26.25rem;
      display: flex;
      align-items: center;
      margin-left: 0.5rem;
      font-size: 1.5rem;
      span {
        margin: 0 0.5rem;
        font-weight: 700;
      }
    }
    &__menu-to-vote {
      box-sizing: border-box;
      cursor: pointer;
      padding: 1rem;
      color: #fefefe;
      font-size: 1.2rem;
      align-items: center;
      font-family: 'Poppins', sans-serif;
      text-transform: uppercase;
      margin: 1rem auto 0 auto;
      border: 1px solid #df2860;
      border-radius: 5px;
    }
    .menuToVoteActive {
      border: 1px solid #df2860;
      border-radius: 5px;
      color: #fefefe;
    }
    &__column {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    &__column-left {
      width: 100%;
      max-width: 700px;
      margin: 0 auto;
    }
    &__column-right {
      width: 100%;
      max-width: 700px;
      margin: 0 auto;
    }
    &__menu-show-info{
      position: relative;
      color: #c5d0ee;
      font-weight: 700;
      margin-left: 0.6rem;
      line-height: 1.4;
      font-size: 2rem;
      min-width: 10rem;
      z-index: 4;
    }
    &__menu-show-options {
      position: absolute;
      max-height: 10rem;
      width: 100%;
      overflow: auto;
      background-color: #fff;
      div {
        cursor: pointer;
        font-size: 1.5rem;
        color: #0f1626;
        font-weight: 400;
        display: flex;
        width: 100%;
        justify-content: center;
        line-height: 2;
      }
    }
  }
</style>
<style>
  .vs__actions {
    cursor: pointer;
  }
  .vs__dropdown-toggle {
    border: none;
    font-size: 1.4rem;
  }
  button.vs__clear {
    display: none;
  }
  span.vs__selected {
    color: #c5d0ee;
    font-weight: 700;
    padding-left: 0;
    padding-right: 0;
    margin-left: 0.35rem;
    width: 7rem;
    font-size: 2.5rem;
    display: flex;
    justify-content: center;
  }
  input.vs__search {
    display: none;
  }
  .v-select.vs--single.vs--searchable {
    width: 5rem;
  }
  .vs--single.vs--open .vs__selected {
    position: relative;
    opacity: .4;
  }
  .vs__dropdown-menu {
    width: 10rem;
    max-height: 210px;
    min-width: unset;
  }
  .vs__selected-options {
    flex-grow: unset;
    padding: 0;
    justify-content: center;
  }
  svg.vs__open-indicator {
    fill: #df2860;
    transform: scale(0.7) !important;
    cursor: pointer;
  }
  .vs__dropdown-option {
    font-size: 2rem;
  }
  ::-webkit-scrollbar {
    width: 10px;
  }
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
  ::-webkit-scrollbar-thumb {
    background: #df2860;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: #952d6e;
  }
</style>
